import { AllProductTypes } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/types.ts';

export enum StoreProductQnaType {
  BOARD = 'BOARD',
  SNS = 'SNS',
}

/* 스토어 정보와 상품 정보가 담긴 크리에이터 상품 최상위 개념 */
export type StoreProduct = AllProductTypes;
